import React, { useContext, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';

import { useKeyDown } from 'hooks/use-keydown';
import { UIContext } from 'context/ui';

import { LanguageControl } from 'components/language-control/LanguageControl';
import { SearchButton } from 'components/search-button/SearchButton';

import { NavControls } from './NavControls';

import s from './Nav.scss';

interface IProps {
  children: React.ReactNode;
  secondary: React.ReactNode;
}

export const Nav = ({ children, secondary }: IProps) => {
  const { navOpen, toggleNav, isDesktop, isIE11 } = useContext<any>(UIContext);
  const navRef = useRef<HTMLElement>(null);
  const innerRef = useRef<HTMLDivElement>(null);
  const primaryRef = useRef<HTMLUListElement>(null);
  const keys = useKeyDown();
  const intl = useIntl();

  useEffect(() => {
    if (!navOpen) {
      return;
    }
    if (keys.includes('Esc') || keys.includes('Escape')) {
      toggleNav(false);
    }
  }, [keys]);

  useEffect(() => {
    if (!innerRef.current) {
      return;
    }

    if (navOpen && !isIE11) {
      innerRef.current.scrollTo(0, 0);
    }

  }, [navOpen]);

  return (
    <>
      <NavControls />
      <nav ref={navRef} className={s('nav', { open: navOpen })} id="main-menu">
        <button className={s.nav__backdrop} onClick={() => { toggleNav(false); }} />
        <div className={s.nav__inner} ref={innerRef}>
          <div className={s.nav__listGroup}>
            <ul className={s.nav__primary} ref={primaryRef}>
              {children}

              {!isDesktop && (
                <ul className={s.nav__actions}>
                  <li className={s.nav__actionsItem}><LanguageControl /></li>
                  <li className={s.nav__actionsItem}><SearchButton /></li>
                </ul>
              )}
            </ul>

            <div className={s.nav__secondary}>
              {secondary}
            </div>

          </div>

          <div className={s.nav__close}>
            <button
              className={s.nav__closeButton}
              onClick={() => {
                toggleNav(false);
              }}
            >
              {intl.formatMessage({ id: 'close', defaultMessage: 'Loka' })}
            </button>
          </div>
        </div>
      </nav>
    </>
  );
};
